export enum AttendanceScoreAction {
  WORK_SHIFT = "WORK_SHIFT",
  CANCEL_SHIFT = "CANCEL_SHIFT",
  NO_CALL_NO_SHOW = "NO_CALL_NO_SHOW",
  CORRECT_SCORE = "CORRECT_SCORE",
  ACCOUNT_RE_ENROLL = "ACCOUNT_RE_ENROLL",
  START_SHIFT_LATE = "START_SHIFT_LATE",
  CLIPBOARD_SCORE_LAUNCH = "CLIPBOARD_SCORE_LAUNCH",
  WORKER_LEFT_EARLY_WITHOUT_PERMISSION = "WORKER_LEFT_EARLY_WITHOUT_PERMISSION",
  REDEEM_SCORE = "REDEEM_SCORE",
  CLOCKIN_TIMELINESS_BONUS = "CLOCKIN_TIMELINESS_BONUS",
  QUALITY_BONUS = "QUALITY_BONUS",
  ORIENTATION_PASSED = "ORIENTATION_PASSED",
  ORIENTATION_ACTIVATION = "ORIENTATION_ACTIVATION",
  ORIENTATION_DEACTIVATION = "ORIENTATION_DEACTIVATION",
  CUSTOM_BONUS = "CUSTOM_BONUS",
  GROUP_ATTENDANCE = "GROUP_ATTENDANCE",
  ADD_FRIEND_BONUS = "ADD_FRIEND_BONUS",
  ON_CALL_SHIFT_CLAIMED = "ON_CALL_SHIFT_CLAIMED",
  ON_CALL_SHIFT_CANCELED = "ON_CALL_SHIFT_CANCELED",
  ON_CALL_SHIFT_WORKER_CANCELLED = "ON_CALL_SHIFT_WORKER_CANCELLED",
  ON_CALL_SHIFT_SYSTEM_CANCELLED = "ON_CALL_SHIFT_SYSTEM_CANCELLED",
  SIGN_UP_BONUS = "SIGN_UP_BONUS",
  IN_HOME_NO_LOG = "IN_HOME_NO_LOG",
  IN_HOME_NO_CONFIRMATION = "IN_HOME_NO_CONFIRMATION",
  IN_HOME_VISIT_DROPPED = "IN_HOME_VISIT_DROPPED",
  IN_HOME_VISIT_APPROVED = "IN_HOME_VISIT_APPROVED",
}

export const readableActionLabelMap = new Map<AttendanceScoreAction, string>([
  [AttendanceScoreAction.WORK_SHIFT, "Worked Shift"],
  [AttendanceScoreAction.CANCEL_SHIFT, "Cancelled Shift"],
  [AttendanceScoreAction.NO_CALL_NO_SHOW, "No Show"],
  [AttendanceScoreAction.CORRECT_SCORE, "Score Correction"],
  [AttendanceScoreAction.ACCOUNT_RE_ENROLL, "Account Re-enrolled"],
  [AttendanceScoreAction.START_SHIFT_LATE, "Arrived late"],
  [AttendanceScoreAction.CLIPBOARD_SCORE_LAUNCH, "Clipboard Score Launch Bonus"],
  [AttendanceScoreAction.WORKER_LEFT_EARLY_WITHOUT_PERMISSION, "Abandoned Shift"],
  [AttendanceScoreAction.REDEEM_SCORE, "Score Redemption"],
  [AttendanceScoreAction.CLOCKIN_TIMELINESS_BONUS, "Arrived on time"],
  [AttendanceScoreAction.QUALITY_BONUS, "Quality Bonus"],
  [AttendanceScoreAction.ORIENTATION_PASSED, "Demo Shift Passed"],
  [AttendanceScoreAction.ORIENTATION_ACTIVATION, "Demo Shift Activated"],
  [AttendanceScoreAction.ORIENTATION_DEACTIVATION, "Demo Shift Deactivated"],
  [AttendanceScoreAction.CUSTOM_BONUS, "Custom Bonus"],
  [AttendanceScoreAction.GROUP_ATTENDANCE, "Group Attendance"],
  [AttendanceScoreAction.ADD_FRIEND_BONUS, "Referral Bonus"],
  [AttendanceScoreAction.ON_CALL_SHIFT_CLAIMED, "On-call Shift Claimed"],
  [AttendanceScoreAction.ON_CALL_SHIFT_CANCELED, "On-call Shift Cancelled"],
  [AttendanceScoreAction.ON_CALL_SHIFT_WORKER_CANCELLED, "On-call Shift Cancelled"],
  [AttendanceScoreAction.ON_CALL_SHIFT_SYSTEM_CANCELLED, "On-call Shift Cancelled by System"],
  [AttendanceScoreAction.SIGN_UP_BONUS, "Sign-up Bonus"],
  [AttendanceScoreAction.IN_HOME_NO_LOG, "In-Home: No Visit Logged"],
  [AttendanceScoreAction.IN_HOME_NO_CONFIRMATION, "In-Home: No Confirmation"],
  [AttendanceScoreAction.IN_HOME_VISIT_DROPPED, "In-Home: Visit Dropped"],
  [AttendanceScoreAction.IN_HOME_VISIT_APPROVED, "In-Home: Visit Approved"],
]);

export const DATE_TIMEZONE_FORMAT = "MM/dd/yyyy hh:mm aaa (zzz)"; // using date-fns formatting
export const MAX_ALLOWED_ATTENDANCE_SCORE = 100;
export const SCORE_LOG_TABLE_PAGESIZE = 10;
export const SCORE_LOG_API_PAGE_SIZE = 100;
export const DEFAULT_PAGE_NUMBER = 1;
export enum DisputeCategory {
  WORKER_EMERGENCY_PASS = "WORKER_EMERGENCY_PASS",
  FACTUAL_UNCERTAINTY_PASS = "FACTUAL_UNCERTAINTY_PASS",
}
export const RESTRICTIONS_LOOK_BACK_PERIOD_IN_DAYS = 600;
